// extracted by mini-css-extract-plugin
module.exports = {"deleteIcon":"QueueQuestions_deleteIcon__27pQP","addIcon":"QueueQuestions_addIcon__31szM","editIcon":"QueueQuestions_editIcon__2_hVL"};